import { AiFillWarning } from 'react-icons/ai';
import './WarningBadge.scss';

interface WarningBadgeProps {
  text?: string;
  tooltip?: string;
  size?: number;
}

export const WarningBadge: React.FC<WarningBadgeProps> = ({ text, tooltip, size = 16 }) => (
  <span
    className="warning-badge"
    data-tooltip-id={tooltip ? 'main-tooltip' : undefined}
    data-tooltip-content={tooltip}
  >
    <AiFillWarning size={size} />
    {text && <span>{text}</span>}
  </span>
);
